// extracted by mini-css-extract-plugin
module.exports = {"container":"ns-z","disabled":"os-z","remove":"ps-z"};